module.exports = __webpack_public_path__ + "static/hand.823657da.png";